import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactDatePicker from 'react-datepicker';
import { getReservationGraph } from '../../actions/reservationGraphActions';
import calculateReservationSpace, {
  findFirstReservationTime
} from '../utils/graph/calculateReservations';
import { generateTimes } from '../utils/graph/reservationTimes';
import TimeTable from '../Graph/TimeTable';
import GraphReservationList from '../Graph/GraphReservationList';

export default function FreePlacesPage() {
  const divHeight = 60;
  const [reservationSpaceData, setReservationSpaceData] = useState(null);
  const [startDate, setDate] = useState(new Date());
  const data = useSelector((state) => state.graph);
  const dispatch = useDispatch();
  const times = generateTimes(findFirstReservationTime(data));
  useEffect(() => {
    setReservationSpaceData(calculateReservationSpace(data, divHeight, times));
  }, [data]);
  const handleDatePickerChange = (date) => {
    dispatch(getReservationGraph(date));
    setDate(date);
  };
  return (
    <div className="graph">
      <div
        className="scrollable"
        style={{ maxHeight: '320px', padding: 'auto' }}
      >
        <div className="graph-label">
          <div>
            <span
              className="graph-label__color"
              style={{ backgroundColor: '#324554' }}
            ></span>
            <span className="graph-label__text">Stálé rezervace</span>
          </div>
          <div>
            <span
              className="graph-label__color"
              style={{ backgroundColor: '#d70b2d' }}
            ></span>
            <span className="graph-label__text">Ostatní rezervace</span>
          </div>
        </div>
        <div className="graph-datepicker">
          <ReactDatePicker
            dateFormat="dd.MM.yyyy"
            locale="cs"
            selected={startDate}
            onChange={handleDatePickerChange}
          />
        </div>
        <div className="graph-table ">
          <TimeTable divHeight={divHeight} times={times} />
          <GraphReservationList
            reservationSpaceData={reservationSpaceData}
            divHeight={divHeight}
          />
        </div>
      </div>
    </div>
  );
}
